"use client";

import { useSyncExternalStore } from "react";
import { useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import { ErrorBoundary } from "@/components/error/error-boundary";
import { useListingBrowseContext } from "@/components/listing/browse/context/listing-browse-context";
import { useLocationContext } from "@/components/home/context/location-context";
import { areaGeoPaths, featuredGeoPaths } from "./geo-navigation-paths";
import { GeoNavigationLinks, type GeoNavigationItem } from "./geo-navigation-links";

const subscribe = () => () => {};

export function LiveGeoNavigation({
  initialPaths,
  initialLinks,
  area = false,
}: {
  initialPaths: string[];
  initialLinks: GeoNavigationItem[];
  area?: boolean;
}) {
  const browse = useListingBrowseContext();
  const { location } = useLocationContext();
  const hydrated = useSyncExternalStore(subscribe, () => true, () => false);
  const paths = area
    ? areaGeoPaths({ productSlug: browse.productType, stateCode: browse.stateCode, location, intent: browse.intentFilter })
    : featuredGeoPaths(browse.productType);
  const changed = hydrated && JSON.stringify(paths) !== JSON.stringify(initialPaths);
  const title = area ? "Explore this area" : "Browse by location";
  return changed ? (
    <ErrorBoundary key={JSON.stringify(paths)} label="browse-location-navigation" fallback={null}>
      {paths.length > 0 ? <QueriedGeoNavigation paths={paths} title={title} /> : null}
    </ErrorBoundary>
  ) : <GeoNavigationLinks links={initialLinks} title={title} />;
}

function QueriedGeoNavigation({ paths, title }: { paths: string[]; title: string }) {
  const links = useQuery(api.routes.geoLinks.getByPaths, { paths });
  return <GeoNavigationLinks links={links ?? []} title={title} />;
}
